import React from 'react';
import { connect } from 'react-redux';
import Styled from 'styled-components';
import { viewport, isEUPFlow, isComboFlow, isExternalFlow, isCPCCheckAvailabilityFlow, isRetailFlow, isFooterRequired } from './Helpers/index';
import { Body } from './Typography/index';

const StyledFooter = Styled.footer`
    background:white;
    cursor:Pointer;
    text-decoration:none;
    flex: '0 1 auto';
    margin-top: ${viewport === 'tablet' && isEUPFlow() === 'true' ? '0px' : '30px'};
    position:relative;
    left:0;
    bottom:0;
    `;

const FooterContent = Styled.div`
    padding:8px 0 8px 4px;
`;

class PageFooter extends React.PureComponent {
  render() {
    const type = viewport();
    // const showFooterSection = window?.location?.pathname?.split('/')?.pop()?.split('.')?.[0] === 'plansOverview';
    return (
      <>
        {type !== 'mfapp' && !isComboFlow() && !isExternalFlow() && !isCPCCheckAvailabilityFlow() && !isRetailFlow() && !isFooterRequired() && (
          <StyledFooter className="" style={{ paddingTop: '20px' }}>
            <FooterContent>
              <Body color="#025E8D" size="small">
                <a href="https://www.verizon.com/about/privacy/privacy-policy-summary" target="_blank" aria-label="Privacy Policy opens in a new tab">
                  Privacy Policy
                </a>
              </Body>
            </FooterContent>
          </StyledFooter>
        )}

        {isFooterRequired() && <div id="vz-gf20" />}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const digitalSession = state?.landing?.smartLeadResp?.headerInfo?.sessionId || null;
  return {
    digitalSession,
  };
};

export default connect(mapStateToProps)(PageFooter);
